/**
 * Copyright SimVentions, Inc. Usage, distribution, transferal, and licensing
 * of this source code is protected under SBIR law as described in DFARS 252.227-7018.
 *
 * SBIR data rights fully described in the README.md file in the top level directory of this project.
 */
import outputNodeUrl from "url:../assets/images/output_node.png";

export const outputNodesContent = `
## Summary

Output nodes represent the final transformed data in your pipeline. Once processing is complete, you can download the results from these nodes.

These nodes can only take in inputs from transform nodes.  It's not possible to connect an input node to an output node without an intermediary transform node.

### Anatomy

<img src="${outputNodeUrl}" alt="Transform Node" style="max-width: 300px; height: auto; display: block; margin: 24px auto;" />

- **1** - Input handle, takes data from a transform node edge connection
- **2** - Output data type indicator, changes based on transform node hooked to the output node, remains as a question mark by default
- **3** - Download button, remains disabled until validated transform is ready to be downloaded

### Adding Output Nodes

Click the output button in the control bar to add a new output node. The node will be automatically positioned based on existing transforms.

### Downloading Outputs

Individual outputs can be downloaded by clicking the download button on the output node.

### Batch Download

Use the ZIP download button in the control bar to download all ready outputs at once. This creates a ZIP archive containing all transformed files.

### Building Outputs

A single output node can take in data from several different transform nodes, provided that all of the transformed data is of the same type, for example, XML.

In other words, you can connect several **PX** transform nodes to the same output node, since all of this data will be of type XML.

Dexter "stacks" data in the output node file based on the order that the edge connection was made with the output node.

### Output File Names

By default, output nodes use the name of the input file with a suffix.

### Managing Outputs

- Multiple output nodes can be created for different outputs
- Outputs are automatically cleaned up when connected nodes are deleted
`;
